import { render, staticRenderFns } from "./InspirationView.vue?vue&type=template&id=65875307&"
import script from "./InspirationView.vue?vue&type=script&lang=js&"
export * from "./InspirationView.vue?vue&type=script&lang=js&"
import style0 from "./InspirationView.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports